/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol } from 'sarsaparilla';
import { formatCurrency } from '../../utils/permitUtils';
import { feeNames, convertCartValueToCents } from '../../utils/feeUtils';

const propTypes = {
    lineItems: PropTypes.arrayOf(PropTypes.object),
};

const defaultProps = {
    lineItems: [],
};

export default class FeeEstimate extends React.Component {
    getFeeDisplay(lineItem) {
        const quantity = get(lineItem, 'Quantity', 0);
        const unitPrice = convertCartValueToCents(get(lineItem, 'UnitPrice', 0));
        return {
            name: feeNames.get(get(lineItem, 'FeeType')),
            breakdown: `${quantity} x ${formatCurrency(unitPrice)}`,
            total: quantity * unitPrice,
        };
    }

    renderThreeColumnFee(col1, col2, col3) {
        return (
            <FlexRow>
                <FlexCol xs={12}>{col1}</FlexCol>
                <FlexCol xs={6}>{col2}</FlexCol>
                <FlexCol xs={6} className="rec-price-value pr-3">
                    {col3}
                </FlexCol>
            </FlexRow>
        );
    }

    render() {
        const { lineItems } = this.props;
        return (
            <div className="fee">
                {lineItems.map((lineItem) => {
                    const disp = this.getFeeDisplay(lineItem);
                    if (disp.total !== 0) {
                        return (
                            <div key={`fee-display-${lineItem.Sku}`}>
                                {this.renderThreeColumnFee(
                                    disp.name,
                                    disp.breakdown,
                                    formatCurrency(disp.total)
                                )}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        );
    }
}

FeeEstimate.propTypes = propTypes;
FeeEstimate.defaultProps = defaultProps;
